import { configureStore } from "@reduxjs/toolkit";
import DataSlice from "./DataSlice";
const AppStore = configureStore({
    reducer:{
       data:DataSlice
    }
})

export default AppStore;